import { http } from "@/http";

// Tesorería → Cobranzas (DEF-ADM-032). Todo de solo lectura.
//
// Son dos llamadas y no una a propósito: los totales son del período entero y
// las filas son de la página. Si vinieran juntas, cambiar de página volvería a
// calcular los agregados de todo el mes sin necesidad.
export default {
  // Cifras del encabezado: lo que entra, lo que sale, alertas y tipo de cambio.
  totals(params) {
    return http.get("/api/v1/collections/totals", { params });
  },
  // Una página de la tabla.
  list(params) {
    return http.get("/api/v1/collections", { params });
  },
  // El Excel. responseType blob porque la respuesta es binaria: sin eso axios
  // la parsea como texto y el archivo baja corrupto.
  export(params) {
    return http.get("/api/v1/collections/export", {
      params,
      responseType: "blob",
    });
  },
};
